/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyInfoVo } from './CompanyInfoVo';
import {
    CompanyInfoVoFromJSON,
    CompanyInfoVoFromJSONTyped,
    CompanyInfoVoToJSON,
    CompanyInfoVoToJSONTyped,
} from './CompanyInfoVo';
import type { UserInfoVo } from './UserInfoVo';
import {
    UserInfoVoFromJSON,
    UserInfoVoFromJSONTyped,
    UserInfoVoToJSON,
    UserInfoVoToJSONTyped,
} from './UserInfoVo';

/**
 * 
 * @export
 * @interface UserAndBusinessLicenseInfoVo
 */
export interface UserAndBusinessLicenseInfoVo {
    /**
     * 
     * @type {UserInfoVo}
     * @memberof UserAndBusinessLicenseInfoVo
     */
    userInfoVO?: UserInfoVo;
    /**
     * 
     * @type {CompanyInfoVo}
     * @memberof UserAndBusinessLicenseInfoVo
     */
    chineseCompanyInfo?: CompanyInfoVo;
    /**
     * 韩国公司信息
     * @type {Array<CompanyInfoVo>}
     * @memberof UserAndBusinessLicenseInfoVo
     */
    koreanCompanyInfo?: Array<CompanyInfoVo>;
}

/**
 * Check if a given object implements the UserAndBusinessLicenseInfoVo interface.
 */
export function instanceOfUserAndBusinessLicenseInfoVo(value: object): value is UserAndBusinessLicenseInfoVo {
    return true;
}

export function UserAndBusinessLicenseInfoVoFromJSON(json: any): UserAndBusinessLicenseInfoVo {
    return UserAndBusinessLicenseInfoVoFromJSONTyped(json, false);
}

export function UserAndBusinessLicenseInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAndBusinessLicenseInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userInfoVO': json['userInfoVO'] == null ? undefined : UserInfoVoFromJSON(json['userInfoVO']),
        'chineseCompanyInfo': json['chineseCompanyInfo'] == null ? undefined : CompanyInfoVoFromJSON(json['chineseCompanyInfo']),
        'koreanCompanyInfo': json['koreanCompanyInfo'] == null ? undefined : ((json['koreanCompanyInfo'] as Array<any>).map(CompanyInfoVoFromJSON)),
    };
}

export function UserAndBusinessLicenseInfoVoToJSON(json: any): UserAndBusinessLicenseInfoVo {
    return UserAndBusinessLicenseInfoVoToJSONTyped(json, false);
}

export function UserAndBusinessLicenseInfoVoToJSONTyped(value?: UserAndBusinessLicenseInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userInfoVO': UserInfoVoToJSON(value['userInfoVO']),
        'chineseCompanyInfo': CompanyInfoVoToJSON(value['chineseCompanyInfo']),
        'koreanCompanyInfo': value['koreanCompanyInfo'] == null ? undefined : ((value['koreanCompanyInfo'] as Array<any>).map(CompanyInfoVoToJSON)),
    };
}

